import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { CheckoutFreeDomainInCheckout } from './CheckoutFreeDomainInCheckout';
import { CheckoutFreeDomainMatchCycle } from '../CheckoutFreeDomainMatchCycle';
export const CheckoutSummaryFreeDomain = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  if (experiments.isEnabled('freeDomainInCheckout')) {
    return /*#__PURE__*/React.createElement(CheckoutFreeDomainInCheckout, null);
  }
  if (experiments.isEnabled('matchDomainCycleToPremiumCycle')) {
    return /*#__PURE__*/React.createElement(CheckoutFreeDomainMatchCycle, null);
  }
  return null;
};
//# sourceMappingURL=CheckoutSummaryFreeDomain.js.map